import React, {Component} from 'react'
import {Form, Select} from 'antd';
import PropTypes from 'prop-types';
import {deepCompare} from '../../utills/common'

export default class SelectAreaFormItem extends Component {
    constructor(props) {
        super(props)
    }

    // componentWillReceiveProps
    componentWillReceiveProps(nextProps) {
        const flag = nextProps.data && Array.isArray(nextProps.data) && nextProps.data.length > 0;
        /*if (flag) {
         debugger
         console.log(nextProps)
         }*/
        return flag
    }

    render() {
        let options = [];
        if (this.props.data != null) {
            this.props.data.forEach(
                d => {
                    options.push(<Select.Option key={d.cityId}
                                                value={d.cityName}>{d.countryName + ' ' + d.cityName}</Select.Option>)
                })
            /*  this.state.origin.map(d => <Option key={d.cityId}
             value={d.cityName}>{d.countryName + ' ' + d.cityName}</Option>);*/

        }
        return <Form.Item label={this.props.label}>
            {this.props.getFieldDecorator(this.props.name, {
                initialValue: this.props.initialValue,
                rules: [{required: true, message: '该项必填'}]
            })(<Select onChange={this.props.handleChange}
                       getPopupContainer={triggerNode => triggerNode.parentNode}
                       disabled={this.props.disabledOpt}
                       showSearch
                       optionFilterProp="children"
                       filterOption={(input, option) => option.props.children.includes(input)}
                       >
                {options}
            </Select>)}
        </Form.Item>

    };
}
/*
 SelectAreaFormItem.propTypes = {
 operation: PropTypes.func,
 disabledOpt: PropTypes.bool,
 options: PropTypes.array,
 realValue: PropTypes.string,
 };
 const areEqual = (prevthis.props, nextthis.props) => {
 /!** 与shouldComponentUpdate相似，但是这是用来判断prevthis.props和nextthis.props是否相等，相
 **  等返回true,组件不发生重新渲染；反之，组件重新渲染。主要用于性能优化，不要过于依
 **  赖，容易发生bug
 **!/
 const flag = prevthis.props.value === nextthis.props.value && deepCompare(prevthis.props.data, nextthis.props.data);
 return flag;
 }
 export default React.memo(SelectAreaFormItem, areEqual);*/

